/**
 * TMS モデル管理ファイル
 * 新しいTMSデバイスを追加する場合は、このファイルにエントリを追加するだけでOK
 */

export const TMS_MODELS = [
  {
    id: 'tms000',
    name: 'TMS#000',
    description: '温度監視システム1号機',
    displayName: 'TMS#000',
    icon: 'HiOutlineDatabase'
  }
];

/**
 * 指定したIDのTMSモデル情報を取得
 * @param {string} id - TMSモデルID (例: 'tms000')
 * @returns {Object|null} TMSモデル情報
 */
export const getTMSModel = (id) => {
  return TMS_MODELS.find(model => model.id === id) || null;
};

/**
 * 全てのTMSモデルのリストを取得
 * @returns {Array} TMSモデルリスト
 */
export const getAllTMSModels = () => {
  return [...TMS_MODELS];
};

/**
 * TMSモデルが存在するかチェック
 * @param {string} id - TMSモデルID
 * @returns {boolean} 存在するかどうか
 */
export const isValidTMSModel = (id) => {
  return TMS_MODELS.some(model => model.id === id);
};

/**
 * API用のベースURL構築
 * @param {string} modelId - TMSモデルID
 * @returns {string} API URL
 */
export const buildTMSApiUrl = (modelId) => {
  return `${process.env.REACT_APP_TMS_BASE_URL}/${modelId}`;
};
